import React from 'react';
import PropTypes from 'prop-types';

import { parseRadiusOptions } from './helpers';
import { GlobalsContext, globals } from './context/globals';
import { labelsPropTypes, dataAttributePropTypes } from './prop-types';

import { StoreProvider } from './store/StoreContext';
import GetGeoData from './GetGeoData';
import App from './App';


const WhatsOnSearch = ({
  api,
  labels,
  data,
  parentItemId,
  googleHasLoaded,
}) => {
  const combinedGlobals = {
    globals: {
      ...globals, // globals defaults, imported data should overwrite all
      api,
      labels: {
        ...globals.labels,
        ...labels,
      },
      categories: data.categories || globals.categories,
      radiusOptions: parseRadiusOptions(
        data.radiusOptions,
        globals.labels.radiusPlaceholder || labels.radiusPlaceholder,
      ),
      defaultLocationRadiusValue: data.defaultLocationRadiusValue,
      googleApiKey: data.googleApiKey,
      types: data.types || globals.types,
      parentItemId,
    },
  };
  return (
    <GlobalsContext.Provider value={combinedGlobals}>
      <GetGeoData googleHasLoaded={googleHasLoaded}>
        {({ getGeoData }) => (
          <StoreProvider>
            <App getGeoData={getGeoData} />
          </StoreProvider>
        )}
      </GetGeoData>
    </GlobalsContext.Provider>
  );
};

WhatsOnSearch.propTypes = {
  api: PropTypes.string.isRequired,
  labels: labelsPropTypes,
  data: dataAttributePropTypes,
  parentItemId: PropTypes.string.isRequired,
  googleHasLoaded: PropTypes.func.isRequired,
};

export default WhatsOnSearch;
